import Vue from 'vue';
import i18n from './i18n/lang';

// override $t because of [[ ]] -> {{ }} replacement
Vue.prototype.$t = function (path: string, args) {
  const translation = i18n.t(path, args).toString();
  return translation.replace(/\[\[/g, '{{').replace(/\]\]/g, '}}');
};
